import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ConfirmProtectionButtonStyled } from '../common/ScreenAndProtectCommon.styles';

const ConfirmProtectionButton = () => {
  const { isValid, isSubmitting } = useFormState();
  const { t } = useTranslation();

  return (
    <ConfirmProtectionButtonStyled
      disabled={!isValid || isSubmitting}
      type="submit"
      $colorScheme="green"
      data-testid="screen-and-protect-details-confirm-protection-button"
      data-intercom-target="details-screen-protect-confirm-button"
    >
      {t('pageScreenAndProtect.detailsPage.actions.confirmProtection')}
    </ConfirmProtectionButtonStyled>
  );
};

export default ConfirmProtectionButton;
